import TYPOGRAPHY from './typography';

const TYPOGRAPHY_FLAT = {
  ...TYPOGRAPHY.headings,
  ...TYPOGRAPHY.paragraph,
  ...TYPOGRAPHY.paragraphLight,
  ...TYPOGRAPHY.buttons,
  ...TYPOGRAPHY.code,
};
export type T_TYPOGRAPHY_FLAT = typeof TYPOGRAPHY_FLAT;
export type FONTSIZES = T_TYPOGRAPHY_FLAT[keyof T_TYPOGRAPHY_FLAT]['fontSize'];
export default TYPOGRAPHY_FLAT;
